import React from 'react';

const Select = ({
  options,
  id,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  ...rest
}) => {
  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`selecionar ${msgErro ? 'erro' : ''}`}>
      <label className='subtitulo-p' htmlFor={id}>{label}</label>
      
      <div className="select-container">
        <i className="ic-marcador-abaixo ic-selecionar"></i>

        <select
          id={id}
          name={name}
          ref={inputRef}
          {...rest}
          className={msgErro ? 'invalid' : ''}
        >
          {options.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
      <div className="mensagem legenda">{msgErro}</div>
    </div>
  );
};

export default Select;
